import React, { useEffect, useState } from 'react';
import api from '../services/api';

const fmtDag = (d) => new Date(d).toLocaleDateString('nl-NL', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
const dagKey = (d) => new Date(d).toISOString().slice(0, 10);

export default function Nieuw() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get('/changelog').then((r) => setItems(r.data.items || [])).catch(() => {}).finally(() => setLoading(false)); }, []);

  const groepen = items.reduce((acc, it) => { const k = dagKey(it.datum); (acc[k] = acc[k] || []).push(it); return acc; }, {});

  return (
    <div className="nieuw-page">
      <div className="page-header">
        <div className="page-header-left">
          <h1>🆕 Wat is nieuw</h1>
          <span className="welcome-text">Verbeteringen en gemaakte ideeën, nieuwste bovenaan.</span>
        </div>
      </div>
      {loading ? <p style={{ color: '#6b7280' }}>Laden…</p>
      : items.length === 0 ? <div className="info-card" style={{ textAlign: 'center', color: '#6b7280' }}>Nog niks te melden.</div>
      : Object.entries(groepen).map(([k, lijst]) => (
        <div key={k} style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: '#6b7280', textTransform: 'capitalize', marginBottom: 8 }}>{fmtDag(lijst[0].datum)}</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {lijst.map((it) => (
              <div key={`${it.type}-${it.id}`} className="info-card" style={{ display: 'flex', gap: 14, alignItems: 'flex-start', padding: '14px 18px', margin: 0 }}>
                <span style={{ fontSize: 20 }}>{it.type === 'idee' ? '💡' : '✨'}</span>
                <div>
                  <div style={{ fontWeight: 600 }}>{it.titel}{it.type === 'idee' && <span style={{ marginLeft: 8, fontSize: 12, background: '#d1fae5', color: '#065f46', padding: '2px 8px', borderRadius: 20 }}>idee gemaakt</span>}</div>
                  {it.tekst && <div style={{ color: '#4b5563', fontSize: 14, marginTop: 4, whiteSpace: 'pre-wrap' }}>{it.tekst}</div>}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
